module.exports = __webpack_public_path__ + "static/media/imac-scrn-seo.0de4523b.jpg";